// This is just for transition out and in when navigating to a new page

// note to myself: using body>.lay-content on many places so this wont animate columns in overlays

import projects_overlays from '../../projects_overlays/projects_overlays'
import { Utility, getVisibleMasonryColumns, waitForMasonryInitialized, isInsideViewport } from '../../utility/utility_controller'
import { fadeIn_SiteTitle_MenuBar_Menu_etc, getUiFadeTargets } from '../shared/fadeIn_SiteTitle_MenuBar_Menu_etc'
import { getStaggerDelayMs } from '../shared/geatEasedStaggerDelay'
import { clearNavStaggerDevOverlay, installNavStaggerDevModeGlobals, isNavStaggerDevModeEnabled, logNavStaggerDebug, renderNavStaggerDevOverlay } from './nav_stagger_dev_tools'
import { waitForInviewImagesLoaded } from '../shared/waitForImageLoad'
import { sortByVisual } from '../shared/sortByVisual'
import '../shared/setEasings'
import { getColumnsToAnimate } from '../shared/getColumnsToAnimate'
import { normalizeStaggerTargets, getNormalizedStaggerIndex, getNormalizedStaggerLength, clearNormalizedStaggerTargets } from '../shared/normalizeStaggerTargets'
import animation_lifecycle_controller from '../lifecycle/animation_lifecycle_controller'
import { NAVIGATION_ANIMATION_PHASES } from '../lifecycle/animation_lifecycle_events'
import { getNavigationScopeForType, SCOPES } from '../../scope/scope'
import visibility_gate from '../lifecycle/visibility_gate'
import history_controller from '../../history/history_controller_new'
var selectorsForAnimationForProjectOverlay = '#lay-project-overlay .grid-inner, #lay-project-overlay .footer.grid'
var rowBackgroundNavTargetSelector = '.row.has-background > .lay-row-bg-color, .row.has-background > .background-image, .row.has-background > .background-video, .row.has-background > .lay-webgl-slideshow, .row.has-background > .lay-row-canvas-animation:not(.lay-row-canvas-animation-field-zoom), .row.has-background > .lay-row-bg-color-fade, .row > .lay-row-gutter-bg'
var rowBackgroundTranslateFactor = 0.35
var minScaledTranslate = 72
var navTransitionTargetClass = 'lay-nav-transition-in-target'
var shouldAnimateRowBackgroundsOnScroll = function () {
	var val = layData.misc_options_scroll_transition_animate_row_backgrounds
	return val == null || val === true || val === '1' || val === 1 || val === 'on'
}

var isFirstLoad = true
// `isFirstLoad` only flips to false inside the transition's begin/complete
// (fadeIn_SiteTitle_MenuBar_Menu_etc_helper), which can be ~2.7s after load.
// On first load `content_ready` can fire more than once before then — e.g.
// once from `newpageshown` and again from the spurious initial `sizechanged`
// that triggerSizeChanged emits when previousSizeType is still undefined. Both
// fired while isFirstLoad was still true, so BOTH emitted a first-load
// `transition_in`, producing two competing reveal transitions. The second one
// (delayed by `waitForMasonryInitialized`, which is slow when a Cover is on)
// re-applied the fade from-state opacity:0 to body>.lay-content AFTER the first
// transition had already revealed and cleared it — and if its complete didn't
// run cleanly, the wrap stayed at opacity:0 forever (blank page). Emit the
// first-load revealing transition at most once.
var firstLoadRevealTransitionEmitted = false

var status = ''
var skipNextTransitionOut = false
var transitionInWhenVisibleQueuedByType = {}
var activeTransitionInRecords = []

var el_onscroll_active = layData.element_transition_on_scroll == 'on' ? true : false

var isRowBackgroundNavTarget = function (el) {
	return shouldAnimateRowBackgroundsOnScroll() && !!(el && el.matches && el.matches(rowBackgroundNavTargetSelector))
}

var shouldDeferRevealToCarouselColumn = function (el) {
	return !!(el && el.classList && el.classList.contains('lay-carousel-wrap') && el.closest('.col.type-carousel'))
}

var isIgnoredByScrollReveal = function (el) {
	return !!(el && el.classList && (el.classList.contains('no-animation') || el.classList.contains('no-animate-in-on-scroll')))
}

var isNormalPageScrollSliderActive = function () {
	if (projects_overlays.isOverlayDisplayBlock()) {
		return false
	}
	var html = document.documentElement
	var content = document.querySelector('body>.lay-content')
	if (html && html.classList && (html.classList.contains('scrollslider-active') || html.classList.contains('infinite-scrollslider-active'))) {
		return true
	}
	if (content && content.classList && (content.classList.contains('scrollslider-active') || content.classList.contains('infinite-scrollslider-active'))) {
		return true
	}
	return !!(window.layscrollslider && typeof window.layscrollslider.isActiveHere === 'function' && window.layscrollslider.isActiveHere())
}

var shouldSkipNormalPageContentTransitionIn = function (type) {
	return type !== 'project_overlay' && isNormalPageScrollSliderActive()
}

var finalizeNavTransitionRevealState = function (col) {
	if (!col || !col.classList) {
		return false
	}
	col.style.transitionDelay = ''
	if (col.dataset.layNavTransitionStartedInViewport === '0') {
		if (shouldDeferRevealToCarouselColumn(col) || isIgnoredByScrollReveal(col)) {
			col.classList.remove('below')
			col.classList.remove('in-view')
			delete col.dataset.layRevealLockedUntil
			return false
		}
		col.classList.remove('in-view')
		col.classList.add('below')
		return true
	}
	col.classList.remove('below')
	col.classList.remove('in-view')
	delete col.dataset.layRevealLockedUntil
	return false
}

var revealDeferredNavTransitionTargetIfVisible = function (col) {
	window.requestAnimationFrame(function () {
		if (!col || !col.classList || !col.classList.contains('below')) {
			return
		}
		if (!isInsideViewport(col, 0)) {
			return
		}
		col.style.transitionDelay = ''
		col.classList.remove('below')
		col.classList.add('in-view')
		col.dataset.layRevealLockedUntil = Date.now() + 500
	})
}

var unregisterTransitionInRecord = function (record) {
	var index = activeTransitionInRecords.indexOf(record)
	if (index !== -1) {
		activeTransitionInRecords.splice(index, 1)
	}
}

var completeTransitionInRecord = function (record) {
	if (!record || record.completed) {
		return
	}
	record.completed = true
	unregisterTransitionInRecord(record)
	onTransitionInComplete(record.colsInViewport || [], record.type)
}

var playTransitionInRecord = function (record) {
	if (!record || record.completed || !record.timeline) {
		return
	}
	record.timeline.play()
}

var freezeActiveTransitionInBeforeTransitionOut = function () {
	if (activeTransitionInRecords.length === 0) {
		return
	}
	// A long transition-in may still be running when the user navigates back.
	// Freeze it at its current visual frame so transition-out can start there.
	var records = activeTransitionInRecords.slice()
	for (var i = 0; i < records.length; i++) {
		var record = records[i]
		if (!record || record.completed) {
			continue
		}
		record.completed = true
		unregisterTransitionInRecord(record)
		if (record.timeline) {
			try {
				record.timeline.pause()
			} catch (e) {}
		}
	}
	visibility_gate.cancelPendingSafetyReveal()
}

var getEffectiveTranslateForNavTarget = function (el, translateVal, scaleTranslateToHeight) {
	var effectiveTranslate = translateVal
	if (scaleTranslateToHeight) {
		var h = el.getBoundingClientRect().height
		var minTranslate = Math.min(minScaledTranslate, translateVal)
		var maxTranslate = Math.max(minTranslate, translateVal)
		var viewportHeight = Math.max(1, window.innerHeight || document.documentElement.clientHeight || h || 1)
		// Ease the height ratio so very small elements do not receive almost
		// the full translate distance.
		var heightRatio = Math.sqrt(Math.max(0, Math.min(1, h / viewportHeight)))
		effectiveTranslate = maxTranslate - heightRatio * (maxTranslate - minTranslate)
	}
	if (isRowBackgroundNavTarget(el)) {
		return Math.max(10, effectiveTranslate * rowBackgroundTranslateFactor)
	}
	return effectiveTranslate
}

var getTranslateYFromTransformString = function (transform) {
	if (!transform || transform === 'none') {
		return 0
	}
	if (transform.indexOf('matrix3d(') === 0) {
		var matrix3dValues = transform.substring(9, transform.length - 1).split(',')
		var matrix3dY = parseFloat(matrix3dValues[13])
		return isNaN(matrix3dY) ? 0 : matrix3dY
	}
	if (transform.indexOf('matrix(') === 0) {
		var matrixValues = transform.substring(7, transform.length - 1).split(',')
		var matrixY = parseFloat(matrixValues[5])
		return isNaN(matrixY) ? 0 : matrixY
	}
	if (transform.indexOf('translate3d(') === 0 || transform.indexOf('translate(') === 0) {
		var start = transform.indexOf('(') + 1
		var end = transform.indexOf(')')
		var values = transform.substring(start, end).split(',')
		var yValue = values.length > 1 ? parseFloat(values[1]) : 0
		return isNaN(yValue) ? 0 : yValue
	}
	return 0
}

var getNavTransitionBaseTranslateY = function (el) {
	if (!el) {
		return 0
	}
	var hasParallaxOrOffsetTransform = !!(
		el._layParallaxTransform ||
		(el.classList && el.classList.contains('has-parallax')) ||
		el.hasAttribute('data-yvel') ||
		el.hasAttribute('data-offsetx') ||
		el.hasAttribute('data-offsety')
	)
	if (!hasParallaxOrOffsetTransform) {
		return 0
	}
	var transform = el._layParallaxTransform || (el.style ? el.style.transform : '')
	if (!transform || transform === 'none') {
		try {
			transform = window.getComputedStyle(el).transform
		} catch (e) {}
	}
	return getTranslateYFromTransformString(transform)
}

var isThumbnailGridDetailTarget = function (el) {
	return !!(el && el.matches && el.matches('.thumbnail-wrap, .lay-thumbnailgrid-load-more-wrap') && el.closest('.col.type-thumbnailgrid'))
}

var hasDetailTargetsForThumbnailGridCol = function (targets, col) {
	for (var i = 0; i < targets.length; i++) {
		var target = targets[i]
		if (target !== col && isThumbnailGridDetailTarget(target) && target.closest('.col.type-thumbnailgrid') === col) {
			return true
		}
	}
	return false
}

var removeRedundantThumbnailGridColumns = function (targets) {
	if (!Array.isArray(targets) || targets.length === 0) {
		return targets
	}
	return targets.filter(function (el) {
		if (el && el.classList && el.classList.contains('type-thumbnailgrid') && hasDetailTargetsForThumbnailGridCol(targets, el)) {
			return false
		}
		return true
	})
}

var getNavTargetScrollTop = function (el) {
	if (el && el.closest) {
		var projectOverlay = el.closest('#lay-project-overlay')
		if (projectOverlay) {
			return projectOverlay.scrollTop || 0
		}
	}
	return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
}

var isCoverTargetPastViewportScroll = function (el) {
	if (!el || !el.closest || !el.closest('.cover-region')) {
		return false
	}
	return getNavTargetScrollTop(el) > window.innerHeight
}

var removeCoverTargetsPastViewportScroll = function (targets) {
	if (!Array.isArray(targets) || targets.length === 0) {
		return targets
	}
	return targets.filter(function (el) {
		return !isCoverTargetPastViewportScroll(el)
	})
}

var animations_controller = {
	i: function () {
                      
		installNavStaggerDevModeGlobals()
            
		bindBeforeContentReplacementEvent()
		bindNewPageEvent()
		bindOnContentReady()

		bindTransitionEvents()
	},
	setTransitionStatus: function (s) {
		status = s
	},
	getTransitionStatus: function () {
		return status
	},
	doAfterComplete: function () {
		doAfterComplete()
	},
	skipNextTransitionOut: function () {
		skipNextTransitionOut = true
	},
}

var bindTransitionEvents = function () {
	// we dont account for transition none, because 'transition_out' doesnt even get triggered in this case
	// because in history_controller we circumvent calling 'transition_out'
	window.laytheme.on('transition_out', function () {
		freezeActiveTransitionInBeforeTransitionOut()
		var navigationType = projects_overlays.isOverlayDisplayBlock() ? 'project_overlay' : 'normal'
		animation_lifecycle_controller.setNavigationPhase(NAVIGATION_ANIMATION_PHASES.OUT_STARTED, {
			scope: getNavigationScopeForType(navigationType),
		})
		window.laytheme.emit('navigation_out_start', navigationType)
		status = 'started'
		if (skipNextTransitionOut) {
			skipNextTransitionOut = false
			doAfterComplete()
			return
		}

		var translateVal = Utility.isPhoneSize ? parseInt(layData.navigation_transition_y_translate_phone, 10) : parseInt(layData.navigation_transition_y_translate_desktop, 10)
		// only animate elements in viewport

		var activeColumnSelectors = getColumnSelectorsForNavigationType(navigationType)
		if (!Array.isArray(activeColumnSelectors) || activeColumnSelectors.length === 0) {
			doAfterComplete()
			return
		}

		var $columns = jQuery(activeColumnSelectors.join(','))
		var colsInViewport = removeCoverTargetsPastViewportScroll(removeRedundantThumbnailGridColumns(getColumnsToAnimate($columns, layData.navigation_transition_out, 'transition_out')))
		// sort columms by position left
		// need this because stagger animation depends on this order and dom order can be different than visual order
		if (layData.navigation_transition_out.indexOf('stagger') != -1 && colsInViewport.length > 1) {
                       
			logNavStaggerDebug('out-before-sort', colsInViewport, {
				navigationType: navigationType,
			})
             
			sortByVisual(colsInViewport, layData.navigation_transition_out)
			normalizeStaggerTargets(colsInViewport)
                       
			logNavStaggerDebug('out-after-sort-normalize', colsInViewport, {
				navigationType: navigationType,
			})
             
		}

		// Per-col effective translate. When `scale_to_height` is on,
		// smaller elements move closer to the configured translate value,
		// while large viewport-filling elements move closer to
		// minScaledTranslate. Otherwise uniform translateVal.
		// Same logic as the transition_in path further down.
		var _scaleValOut = layData.navigation_transition_y_translate_scale_to_height
		var scaleTranslateToHeightOut = _scaleValOut === 'on' || _scaleValOut === '1' || _scaleValOut === 1 || _scaleValOut === true
		for (var ci = 0; ci < colsInViewport.length; ci++) {
			var colOut = colsInViewport[ci]
			colOut._layEffectiveTranslate = getEffectiveTranslateForNavTarget(colOut, translateVal, scaleTranslateToHeightOut)
		}

		// fadeout imagehover region
		// if (document.querySelector('.lay-imagehover-region')) {
		// 	anime({
		// 		targets: '.lay-imagehover-region',
		// 		opacity: [1, 0],
		// 		easing: 'easeOutSine',
		// 		duration: 100,
		// 	})
		// 	// jQuery('.lay-imagehover-region').css('opacity', '0');
		// }

		var myTimeline = anime.timeline({
			begin: function () {
				// need to hide cols for collapsed row, cause otherwise they appear while transitioning
				// i have no idea why though
				jQuery('.row[data-collapsed="true"] .col').css('display', 'none')
				// disable links and lightbox in content that is fading out and
				// disable menu and site title links
				if (projects_overlays.isOverlayDisplayBlock()) {
					jQuery('a.sitetitle, .laynav a, #lay-project-overlay a, #lay-project-overlay .col, .clickable-cover, .clickable-cover-arrow').css('pointer-events', 'none')
				} else {
					jQuery('a.sitetitle, .laynav a, body>.lay-content a, body>.lay-content .col, .clickable-cover, .clickable-cover-arrow').css('pointer-events', 'none')
				}
				// need this so filtering/in-view css for the current nav targets doesnt override the following transitions!
				jQuery(colsInViewport)
					.css({
						'transition-delay': '',
						transition: 'none',
					})
					.removeClass('in-view')
				if (el_onscroll_active) {
					// need this so el_onscroll transition doesnt override the following transitions!
					// or filtering css for thumbnailgrid
					var activeTransitionColSelector = projects_overlays.isOverlayDisplayBlock() ? '#lay-project-overlay .col' : 'body>.lay-content .col'
					jQuery(activeTransitionColSelector).css({
						'transition-delay': '',
						transition: 'none',
					})
					// so up or stagger up animation doesnt get cut off on last element in last row
					jQuery('body.lay-transition-elements-on-scroll .row.no-y-offsets:last-child').css('overflow', 'visible')
				}
			},
			complete: function () {
				clearNormalizedStaggerTargets(colsInViewport)
                        
				if (!isNavStaggerDevModeEnabled()) {
					clearNavStaggerDevOverlay()
				}
              
				doAfterComplete()
			},
		})

		var onlyAnimateWrap = layData.navigation_transition_out == 'none' || layData.navigation_transition_out == 'fade' ? true : false

		var targets = projects_overlays.isOverlayDisplayBlock() ? selectorsForAnimationForProjectOverlay : 'body>.lay-content'

		// only animating one dom element is just more performant!
		// we could also do up and down by just animating wrap, however, this creates a bug with a background image in chrome
		// and it also moves the wrap's background image which looks weird maybe
		if (onlyAnimateWrap) {
			switch (layData.navigation_transition_out) {
				case 'fade':
					myTimeline.add({
						targets: targets,
						opacity: 0,
						easing: layData.navigation_transition_out_easing,
						duration: layData.navigation_transition_out_duration,
					})
					break
			}
		} else {
			var doColAnimations = true
			if (window.layscrollslider && window.layscrollslider.isActiveHere()) {
				doColAnimations = false
			}

			if (doColAnimations) {
				// Stagger from Lay Options — replaces the legacy
				// `getEasedStaggerDelayForTransitionOut(idx, length)`
				// which divided a fixed 500ms budget across all slots
				// and made the cascade nearly imperceptible with many
				// cols. New formula: `staggerMs × idx × easing`.
				var navOutStaggerMs = parseInt(layData.navigation_transition_out_stagger, 10)
				if (!isFinite(navOutStaggerMs) || navOutStaggerMs < 0) navOutStaggerMs = 60
				var navOutEasing = layData.navigation_transition_out_easing || 'easeOutSine'
				var navOutStaggerDelayEasing = 'linear'
				var computeNavOutDelay = function (el, index, length) {
					return getStaggerDelayMs(getNormalizedStaggerIndex(el, index), getNormalizedStaggerLength(el, length), navOutStaggerMs, navOutStaggerDelayEasing)
				}
				var navOutBaseDuration = parseInt(layData.navigation_transition_out_duration, 10) || 0
                        
				if (layData.navigation_transition_out.indexOf('stagger') != -1) {
					var navStaggerDevOptions = {
						navigationType: navigationType,
						staggerMs: navOutStaggerMs,
						easing: navOutEasing,
						delayEasing: navOutStaggerDelayEasing,
						baseDuration: navOutBaseDuration,
						transitionOut: layData.navigation_transition_out,
					}
					logNavStaggerDebug('out-final-delay-values', colsInViewport, navStaggerDevOptions)
					renderNavStaggerDevOverlay(colsInViewport, navStaggerDevOptions)
				}
              
				// Per-element translateY value (positive for stagger-down/down,
				// negative for stagger-up/up). Reads each col's pre-computed
				// `_layEffectiveTranslate` (= height-scaled when the option
				// is on, else uniform translateVal).
				var translateOutDownFn = function (el) {
					return (el._layEffectiveTranslate !== undefined) ? el._layEffectiveTranslate : translateVal
				}
				var translateOutUpFn = function (el) {
					var d = (el._layEffectiveTranslate !== undefined) ? el._layEffectiveTranslate : translateVal
					return -d
				}
				// first hide single elements
				switch (layData.navigation_transition_out) {
					case 'stagger-fade':
						myTimeline.add({
							targets: colsInViewport,
							opacity: 0,
							easing: layData.navigation_transition_out_easing,
							duration: layData.navigation_transition_out_duration,
							delay: computeNavOutDelay,
						})
						break
					case 'stagger-down':
						myTimeline.add({
							targets: colsInViewport,
							translateY: translateOutDownFn,
							opacity: 0,
							easing: layData.navigation_transition_out_easing,
							duration: layData.navigation_transition_out_duration,
							delay: computeNavOutDelay,
						})
						break
					case 'stagger-up':
						myTimeline.add({
							targets: colsInViewport,
							translateY: translateOutUpFn,
							opacity: 0,
							easing: layData.navigation_transition_out_easing,
							duration: layData.navigation_transition_out_duration,
							delay: computeNavOutDelay,
						})
						break
					case 'down':
						myTimeline.add({
							targets: colsInViewport,
							translateY: translateOutDownFn,
							opacity: 0,
							easing: layData.navigation_transition_out_easing,
							duration: layData.navigation_transition_out_duration,
						})
						break
					case 'up':
						myTimeline.add({
							targets: colsInViewport,
							translateY: translateOutUpFn,
							opacity: 0,
							easing: layData.navigation_transition_out_easing,
							duration: layData.navigation_transition_out_duration,
						})
						break
				}
			}
			// then hide wraps
			myTimeline.add({
				targets: projects_overlays.isOverlayDisplayBlock() ? '#lay-project-overlay>.lay-content' : 'body>.lay-content',
				opacity: 0,
				easing: 'easeOutSine',
				duration: 100,
			})
		}
	})

	window.laytheme.on('transition_in', function (type) {
		animation_lifecycle_controller.setNavigationPhase(NAVIGATION_ANIMATION_PHASES.IN_PREPARING, {
			scope: getNavigationScopeForType(type),
		})
		// wait because transition_in might get called directly after hide stylesheet is inserted into dom
		setTimeout(function () {
			var activeColumnSelectors = getColumnSelectorsForNavigationType(type)
			if (!Array.isArray(activeColumnSelectors) || activeColumnSelectors.length === 0) {
				doTransitionIn(type)
				return
			}
			var $parents = jQuery(activeColumnSelectors.join(','))
			var masonryCols = getVisibleMasonryColumns($parents)

			// `getColumnsToAnimate` (inside `doTransitionIn`) reads viewport
			// position from `getBoundingClientRect`. On a popstate back-nav
			// (especially project-overlay → project-overlay) the scroll
			// position is restored asynchronously by history_controller —
			// after masonry init, or after 100ms for thumbnailgrid pages, or
			// after fpAfterRender. If we ran first, only the topmost cols
			// would be "in viewport" and elements at the restored scroll
			// position would pop in without staggering. Await both layout
			// readiness (masonry) and scroll-restore explicitly.
			var masonryPromise = masonryCols.length > 0
				? Promise.resolve(jQuery.when(waitForMasonryInitialized(masonryCols)))
				: Promise.resolve()
			var scrollPromise = history_controller.getScrollRestoreReady
				? history_controller.getScrollRestoreReady()
				: Promise.resolve()
			// Safety-net: if either promise gets stuck for any reason, fall
			// back so transition_in always runs (better a degraded stagger
			// than a blank page).
			var safetyTimeout = new Promise(function (resolve) { setTimeout(resolve, 1500) })

			Promise.race([Promise.all([masonryPromise, scrollPromise]), safetyTimeout])
				.then(function () {
					doTransitionIn(type)
				})
				.catch(function () {
					doTransitionIn(type)
				})
		}, 0)
	})
}

var doTransitionIn = function (type) {
	if (!animation_lifecycle_controller.isDocumentVisible()) {
		var queueKey = type || 'normal'
		if (transitionInWhenVisibleQueuedByType[queueKey]) {
			return
		}
		transitionInWhenVisibleQueuedByType[queueKey] = true
		animation_lifecycle_controller.runWhenDocumentVisible(function () {
			transitionInWhenVisibleQueuedByType[queueKey] = false
			doTransitionIn(type)
		})
		return
	}
	// Defensively cancel any in-flight safety-net reveal from a previous
	// transition. The gate's `hideScope` / `showScope` calls already cancel,
	// but for `transition_in` paths that don't go through one of those, this
	// guarantees the prior safety net can't fire and rip down a freshly-set
	// hide-css mid-animation.
	visibility_gate.cancelPendingSafetyReveal()
	// when transition is 'none', even though i use anime and timeline, the events "begin" and "complete"
	// dont get triggered, which i think is a animejs bug

	status = 'started'
	animation_lifecycle_controller.setNavigationPhase(NAVIGATION_ANIMATION_PHASES.IN_STARTED, {
		scope: getNavigationScopeForType(type),
	})
	// Pass `type` ('normal' | 'project_overlay') so listeners can distinguish
	// a page-content transition from an overlay-opening transition. Without
	// this, e.g. opening a project overlay while the page's own intro is still
	// running would freeze the page intro mid-flight (scrub.js cancels the
	// intro RAF on `transition_navigation_in_started`).
	window.laytheme.emit('parallaxrefresh', 'navigation_in_before_stagger_setup')
	window.laytheme.emit('transition_navigation_in_started', type)
	window.laytheme.emit('navigation_in_start', type)

	var translateVal = Utility.isPhoneSize ? parseInt(layData.navigation_transition_y_translate_phone, 10) : parseInt(layData.navigation_transition_y_translate_desktop, 10)
	var currentScope = getNavigationScopeForType(type)

	if (shouldSkipNormalPageContentTransitionIn(type)) {
		window._layAnimTimeOrigin = performance.now()
		visibility_gate.showScope(SCOPES.NORMAL_PAGE)
		visibility_gate.showScope(SCOPES.PROJECT_OVERLAY)
		fadeIn_SiteTitle_MenuBar_Menu_etc_helper(0, null, currentScope)
		onTransitionInComplete([], type, { skipContentStyleCleanup: true })
		return
	}

	// only animate elements in viewport

	var activeColumnSelectors = getColumnSelectorsForNavigationType(type)
	if (!Array.isArray(activeColumnSelectors) || activeColumnSelectors.length === 0) {
		onTransitionInComplete([], type)
		return
	}

	var $columns = jQuery(activeColumnSelectors.join(','))
	var colsInViewport = removeRedundantThumbnailGridColumns(getColumnsToAnimate($columns, layData.navigation_transition_in, 'transition_in'))
	for (var i = 0; i < colsInViewport.length; i++) {
		if (colsInViewport[i].querySelector && colsInViewport[i].querySelector('[data-lay-build-anim-group]')) {
			colsInViewport[i]._laySyncMute = true
		}
	}

	// Scope token used for the UI cascade so the close-icon (and any
	// other overlay-owned UI) is only enumerated for overlay transitions,
	// not for the underlay page transition. Without this, opening a
	// project overlay fades the close-icon once for the page cascade and
	// then again for the overlay cascade (visible double-fade).
	var uiFadeTargetsForStaggerSync = null
	if (colsInViewport.length > 0 && layData.navigation_transition_in.indexOf('stagger') !== -1) {
		uiFadeTargetsForStaggerSync = getUiFadeTargets(currentScope)
	}
	var uiStaggerCount = uiFadeTargetsForStaggerSync ? uiFadeTargetsForStaggerSync.length : 0

	// just end it here, if there is nothing to animate
	if (colsInViewport.length == 0) {
		fadeIn_SiteTitle_MenuBar_Menu_etc_helper(0, null, currentScope)
		// Reveal everything: there's no animation to coordinate with, so we
		// don't know which scope was hidden — clear both to be safe.
		visibility_gate.showAllScopes()
		onTransitionInComplete([], type)
		return
	}
	// sort columms by position left
	// need this because stagger animation depends on this order and dom order can be different than visual order
	if (layData.navigation_transition_in.indexOf('stagger') != -1 && colsInViewport.length > 1) {
                      
		logNavStaggerDebug('in-before-sort', colsInViewport, {
			debugMode: 'in',
			direction: 'in',
			navigationType: type,
		})
            
		sortByVisual(colsInViewport, layData.navigation_transition_in)
		normalizeStaggerTargets(colsInViewport)
                      
		logNavStaggerDebug('in-after-sort-normalize', colsInViewport, {
			debugMode: 'in',
			direction: 'in',
			navigationType: type,
		})
            
	}
	var colsForTransitionInAnimation = Array.isArray(colsInViewport)
		? colsInViewport.filter(function (col) {
			return !col._laySyncMute
		})
		: colsInViewport
	// same visual order for header/UI fades as for cols (distance from top-left, like sortByVisual)
	if (layData.navigation_transition_in.indexOf('stagger') !== -1 && uiFadeTargetsForStaggerSync && uiFadeTargetsForStaggerSync.length > 1) {
		sortByVisual(uiFadeTargetsForStaggerSync, layData.navigation_transition_in)
	}

	// when animation is none, we dont need to disable lazyload transitions
	// because we reveal the page without waiting for in view images to have loaded
	// Tolerant truthy check: WP saves checkboxes inconsistently — ajax
	// save uses `'on'` / `''`, the form post path may use `'1'` / `'0'`.
	// Accept any non-falsy-string value as "on".
	var _scaleVal = layData.navigation_transition_y_translate_scale_to_height
	var scaleTranslateToHeight = _scaleVal === 'on' || _scaleVal === '1' || _scaleVal === 1 || _scaleVal === true
	if (layData.navigation_transition_in != 'none') {
		// only need this for reveal!
		for (var i = 0; i < colsInViewport.length; i++) {
			var col = colsInViewport[i]
			col.dataset.layNavTransitionStartedInViewport = isInsideViewport(col, 0) ? '1' : '0'
			col.classList.add('disable-css-transitions')
			col.classList.add(navTransitionTargetClass)

			// Store the original inline opacity if it exists, otherwise default to 1
			if (col.style.opacity && col.style.opacity !== '') {
				col._layTargetOpacity = parseFloat(col.style.opacity)
			} else {
				col._layTargetOpacity = 1
			}
			// Per-element translate distance. When the "scale to height"
			// option is on, smaller elements move closer to the configured
			// translate value while large viewport-filling elements move
			// closer to minScaledTranslate. When off, the legacy fixed
			// value is used uniformly.
			col._layEffectiveTranslate = getEffectiveTranslateForNavTarget(col, translateVal, scaleTranslateToHeight)
			col._layNavTransitionBaseTranslateY = getNavTransitionBaseTranslateY(col)
		}
	}

	// fadein imagehover region
	// if (jQuery('.lay-imagehover-region').length > 0) {
	// anime({
	//     targets: '.lay-imagehover-region',
	//     opacity: [0, 1],
	//     easing: 'easeInSine',
	//     duration: 100
	// })
	// jQuery('.lay-imagehover-region').css('opacity', '')
	// }

	var onlyAnimateWrap = layData.navigation_transition_in == 'none' || layData.navigation_transition_in == 'fade' ? true : false
                     
	var navInStaggerDevOptions = null
           

	var transitionInRecord = {
		type: type,
		colsInViewport: colsInViewport,
		timeline: null,
		completed: false,
	}
	var myTimeline = anime.timeline({
		autoplay: false,
		begin: function () {
			// Shared time origin for all visible-at-load animations.
			// Scroll-anim elements (incl. Build Animation Group members)
			// can tick their idle→pending transition before nav-anim has
			// even begun (rAF starts before content_ready fires the
			// transition_in chain). Without a synced origin, their
			// `delayMs` countdown starts ~300ms earlier than the text
			// animations (which wait for the IO observer, attached after
			// content_ready), so a "delay 2000ms" group fires 300ms
			// before a 2000ms-long top text finishes.
			//
			// Always update — not just on first load. On SPA navigations
			// the new page's build-anim members need to sync with the
			// NEW transition's begin time, not the stale one from the
			// initial page load. The build_animation_groups controller's
			// own setupTimeOriginAfterReady() seeds an initial value for
			// the no-nav-anim case; nav-anim begin overrides whenever it
			// fires, which is always the more authoritative timing.
			window._layAnimTimeOrigin = performance.now()
			// Pre-apply the tween's from-state opacity to .col elements
			// BEFORE removing the wrap-hide stylesheet. Without this, on
			// first-load the sequence was:
			//   1. removeWrapHideStyleSheet() reveals body>.lay-content
			//      (which was opacity:0 via PHP-injected CSS)
			//   2. .col elements briefly visible at default opacity 1
			//   3. anime.js advances the tween, snapping .col opacity to 0
			//   4. animation interpolates 0 → 1 over duration
			// User saw: visible flash → invisible → fade-in. Pre-setting
			// opacity:0 here means step 2 already shows .col at 0, so the
			// reveal in step 1 + tween-start in step 3 are perfectly
			// synchronized — no flash.
			//
			// Only for the stagger / up / down cases — for the 'fade' case
			// (onlyAnimateWrap), the tween animates body>.lay-content
			// itself, not the cols, so leaving cols at default opacity is
			// correct.
			if (!onlyAnimateWrap && Array.isArray(colsForTransitionInAnimation)) {
				for (var i = 0; i < colsForTransitionInAnimation.length; i++) {
					colsForTransitionInAnimation[i].style.opacity = '0'
					// The .below reveal class uses opacity:0!important.
					// Once the nav-in from-state is applied inline, keep it
					// out of the actual anime.js tween so opacity can animate.
					colsForTransitionInAnimation[i].classList.remove('below')
				}
			}
			// Reveal both scopes: depending on transition type, the hide-css
			// could have been set on either the page or the project-overlay
			// scope. Showing both is idempotent and matches the previous behavior.
			visibility_gate.showScope(SCOPES.NORMAL_PAGE)
			visibility_gate.showScope(SCOPES.PROJECT_OVERLAY)
			fadeIn_SiteTitle_MenuBar_Menu_etc_helper(colsInViewport.length, uiFadeTargetsForStaggerSync, currentScope)
		},
		complete: function () {
			completeTransitionInRecord(transitionInRecord)
		},
	})
	transitionInRecord.timeline = myTimeline
	activeTransitionInRecords.push(transitionInRecord)
	var targets = ''

	switch (type) {
		case 'project_overlay':
			targets = selectorsForAnimationForProjectOverlay
			break
		default:
			targets = 'body>.lay-content'
	}

	// only animating one dom element is just more performant!
	// we could also do up and down by just animating wrap, however, this creates a bug with a background image in chrome
	// and it also moves the wrap's background image which looks weird maybe

	if (onlyAnimateWrap) {
		switch (layData.navigation_transition_in) {
			case 'none':
				myTimeline.add({
					targets: targets,
					opacity: 1,
					easing: layData.navigation_transition_in_easing,
					duration: 0,
				})
				break
			case 'fade':
				myTimeline.add({
					targets: targets,
					opacity: [0, 1],
					easing: layData.navigation_transition_in_easing,
					duration: layData.navigation_transition_in_duration,
				})
				break
		}
	} else if (colsInViewport != undefined && Array.isArray(colsInViewport) && colsInViewport.length > 0) {
		// first animate in wrap

		myTimeline.add({
			targets: targets,
			opacity: 1,
			easing: 'easeOutSine',
			duration: 0,
		})

		var doColAnimations = true
		if (window.layscrollslider && window.layscrollslider.isActiveHere()) {
			doColAnimations = false
			// if we are in a project overlay, scrollslider will always be disabled, so we can do the transition in.
			if (window.utility_controller.isProjectsOverlayEnabled() && window.projects_overlays.isOverlayDisplayBlock()) {
				doColAnimations = true
			}
		}
		if (!Array.isArray(colsForTransitionInAnimation) || colsForTransitionInAnimation.length === 0) {
			doColAnimations = false
		}

		if (doColAnimations) {
			// Then animate in regular columns. Columns that contain
			// Build Animation Group / Sync-with-Nav elements are kept
			// out of this timeline entirely; their inner element
			// animations own the visual reveal. We still keep the
			// original colsInViewport list around for lifecycle
			// cleanup/completion so neighbouring columns and listeners
			// stay stable.
			//
			// Delay formula switched to the Build Animation modal's
			// per-element-stagger algorithm (`staggerMs × i × easing`):
			// previously `getEasedStaggerDelayForTransitionIn` shared a
			// fixed 500ms budget across ALL slots, so with many UI
			// fades + cols the per-col gap shrank below the human
			// perception threshold (~19ms with 28 slots). Now the
			// stagger comes from a Lay Options field
			// (`navigation_transition_in_stagger`, default 100ms) that
			// produces predictable, visible gaps regardless of cascade
			// length.
			//
			// Col cascade has its OWN stagger context — index 0..N-1
			// across just the cols, without the UI fade targets in the
			// numerator. UI fades cascade independently (same staggerMs)
			// in fadeIn_SiteTitle_MenuBar_Menu_etc.js, starting at t=0.
			// Result: header items and main content sweep in in parallel
			// instead of header-first-then-cols.
			var navInStaggerMs = parseInt(layData.navigation_transition_in_stagger, 10)
			if (!isFinite(navInStaggerMs) || navInStaggerMs < 0) navInStaggerMs = 100
			var navInEasing = layData.navigation_transition_in_easing || 'easeOutSine'
			var computeNavInDelay = function (el, index, length) {
				return getStaggerDelayMs(getNormalizedStaggerIndex(el, index), getNormalizedStaggerLength(el, length), navInStaggerMs, navInEasing)
			}
			var navInBaseDuration = parseInt(layData.navigation_transition_in_duration, 10) || 0
                       
			if (layData.navigation_transition_in.indexOf('stagger') != -1) {
				navInStaggerDevOptions = {
					debugMode: 'in',
					direction: 'in',
					navigationType: type,
					staggerMs: navInStaggerMs,
					easing: navInEasing,
					delayEasing: navInEasing,
					baseDuration: navInBaseDuration,
					transitionIn: layData.navigation_transition_in,
				}
				renderNavStaggerDevOverlay(colsForTransitionInAnimation, navInStaggerDevOptions)
			}
             
			// translateY value functions: per-element distance is the
			// pre-computed `_layEffectiveTranslate` (= height-scaled when
			// the Lay Options checkbox is on, else uniform translateVal).
			var translateUpValueFn = function (el) {
				var d = (el._layEffectiveTranslate !== undefined) ? el._layEffectiveTranslate : translateVal
				var baseY = isFinite(el._layNavTransitionBaseTranslateY) ? el._layNavTransitionBaseTranslateY : getNavTransitionBaseTranslateY(el)
				el._layNavTransitionBaseTranslateY = baseY
				return [d, 0]
			}
			var translateDownValueFn = function (el) {
				var d = (el._layEffectiveTranslate !== undefined) ? el._layEffectiveTranslate : translateVal
				var baseY = isFinite(el._layNavTransitionBaseTranslateY) ? el._layNavTransitionBaseTranslateY : getNavTransitionBaseTranslateY(el)
				el._layNavTransitionBaseTranslateY = baseY
				return [-d, 0]
			}
			var opacityInValueFn = function (el) {
				return [0, el._layTargetOpacity !== undefined ? el._layTargetOpacity : 1]
			}
			switch (layData.navigation_transition_in) {
				case 'stagger-fade':
					myTimeline.add({
						targets: colsForTransitionInAnimation,
						opacity: opacityInValueFn,
						easing: layData.navigation_transition_in_easing,
						duration: layData.navigation_transition_in_duration,
						delay: computeNavInDelay,
					})
					break
				case 'stagger-up':
					myTimeline.add({
						targets: colsForTransitionInAnimation,
						translateY: translateUpValueFn,
						opacity: opacityInValueFn,
						easing: layData.navigation_transition_in_easing,
						duration: layData.navigation_transition_in_duration,
						delay: computeNavInDelay,
					})
					break
				case 'stagger-down':
					myTimeline.add({
						targets: colsForTransitionInAnimation,
						translateY: translateDownValueFn,
						opacity: opacityInValueFn,
						easing: layData.navigation_transition_in_easing,
						duration: layData.navigation_transition_in_duration,
						delay: computeNavInDelay,
					})
					break
				case 'up':
					myTimeline.add({
						targets: colsForTransitionInAnimation,
						translateY: translateUpValueFn,
						opacity: opacityInValueFn,
						easing: layData.navigation_transition_in_easing,
						duration: layData.navigation_transition_in_duration,
					})
					break
				case 'down':
					myTimeline.add({
						targets: colsForTransitionInAnimation,
						translateY: translateDownValueFn,
						opacity: opacityInValueFn,
						easing: layData.navigation_transition_in_easing,
						duration: layData.navigation_transition_in_duration,
					})
					break
			}
		} else {
			playTransitionInRecord(transitionInRecord)

			completeTransitionInRecord(transitionInRecord)
			fadeIn_SiteTitle_MenuBar_Menu_etc_helper(colsInViewport.length, uiFadeTargetsForStaggerSync, currentScope)
		}
	}

	if (layData.navigation_transition_in == 'none') {
		playTransitionInRecord(transitionInRecord)
		// when layData.navigation_transition_in is 'none', myTimeline.complete and begin do trigger
		// so i just call this function here:

		completeTransitionInRecord(transitionInRecord)
		fadeIn_SiteTitle_MenuBar_Menu_etc_helper(colsInViewport.length, uiFadeTargetsForStaggerSync, currentScope)
	} else {
		var $columns = jQuery(activeColumnSelectors.join(','))
		// note to myself: it seems like when using a scroll to hash
		// like: http://localhost:10020/fs-2/#last
		// with fullscreen slider active, this callback is never evoked, so i just look for a # hash and do play
		if (window.location.href.indexOf('#') != -1) {
			playTransitionInRecord(transitionInRecord)
		} else {
			if ((layData.loadingBlur == 'on' && layData.lazyLoading == 'on') || layData.loadingBlur == 'blur') {
				// loadingBlur=on+lazyLoading=on → tiny placeholders, load instantly.
				// loadingBlur=blur → blurred placeholder is already visible, so we
				// can start the stagger immediately and let the full image fade
				// in on top when it loads. Waiting would mean the UI cascade
				// (site title / menu / close icon / nav-anim cols) sits idle
				// until images decode.
				playTransitionInRecord(transitionInRecord)
			} else {
				waitForInviewImagesLoaded($columns, function () {
					playTransitionInRecord(transitionInRecord)
				})
			}
		}
	}

	// Safety net: if waitForInviewImagesLoaded never resolves (e.g. an image
	// 404s and waitFor gives up before timing out), the timeline's `begin`
	// callback won't fire, the hide-wrap stylesheet stays, and the page
	// remains invisible forever. Schedule a delayed removal as fallback.
	//
	// Previously this was a SYNCHRONOUS call here — but on first-load the
	// timeline play is awaiting images, so the stylesheet got removed BEFORE
	// anime.js applied the tween's start-state (opacity 0). The browser then
	// showed the just-revealed .lay-content at full opacity for one frame,
	// then anime.js snapped .col to opacity 0, then faded it back to 1 —
	// the visible "in / out / in" flicker users reported on FS-Slider pages.
	//
	// `begin` callback already handles the normal case (it removes the
	// stylesheet AT the moment anime.js applies the from-state, so the
	// reveal and fade-from-0 are perfectly synchronized).
	visibility_gate.scheduleSafetyReveal(3000)
}

var onTransitionInComplete = function (colsInViewport, type, options) {
	animation_lifecycle_controller.setNavigationPhase(NAVIGATION_ANIMATION_PHASES.IN_ENDED, {
		scope: getNavigationScopeForType(type),
	})
	visibility_gate.showScope(SCOPES.NORMAL_PAGE)
	visibility_gate.showScope(SCOPES.PROJECT_OVERLAY)

	// remove style that was applied to .lay-content
	// this removes probably transform: translateY() and opacity, maybe this fixes a background image issue
	let target = type == 'project_overlay' ? '#lay-project-overlay>.lay-content' : 'body>.lay-content'
	if (!(options && options.skipContentStyleCleanup)) {
		jQuery(target).attr('style', '')
	}
	var delayedCleanupKey = 'navigation-transition-targets'
	var delayedCleanupId = animation_lifecycle_controller.beginDelayedCleanup(delayedCleanupKey)
	// remove this class, maybe it could interfere with sth else, not sure. but it has done its work
	// yes it would! interefere with thumbnailgrid filter animation
	for (var i = 0; i < colsInViewport.length; i++) {
		var col = colsInViewport[i]
		var shouldRevealAfterTransitionsAreEnabled = finalizeNavTransitionRevealState(col)
		col.classList.remove('disable-css-transitions')
		if (shouldRevealAfterTransitionsAreEnabled) {
			revealDeferredNavTransitionTargetIfVisible(col)
		}
		setTimeout(function (target, cleanupId, cleanupKey) {
			if (!animation_lifecycle_controller.isDelayedCleanupCurrent(cleanupId, cleanupKey)) {
				return
			}
			target.classList.remove(navTransitionTargetClass)
			delete target.dataset.layNavTransitionStartedInViewport
		}, 3000, col, delayedCleanupId, delayedCleanupKey)
		// Clean up the temporary property
		delete col._layTargetOpacity
		delete col._layNavTransitionBaseTranslateY
	}
	clearNormalizedStaggerTargets(colsInViewport)
	// also remove all styles that were applied by animations, so for example we can filter a thumbnailgrid
	// without new applied styles interfering
	// we only need this the revealing animation
	for (var i = 0; i < colsInViewport.length; i++) {
		var col = colsInViewport[i]
		// actually, only remove opacity styles from elements inside a elementgrid and thumbnailgrid
		// cause we animate the divs inside the thumbnailgrid and elementgrid
		// if we would remove opacity styles of all .cols, this would remove opacities we set with the new sidebar
		if (col.closest('.type-elementgrid') || col.closest('.type-thumbnailgrid')) {
			col.style.opacity = ''
		}
		if (!col.classList.contains('has-parallax') && !col.hasAttribute('data-offsetx') && !col.hasAttribute('data-offsety')) {
			col.style.transform = ''
		}
		// we cant just remove the whole style attribute because that would destroy the masonry layout
	}

	// just for safety measure, as we already did this on hiding animation complete:
	// re-enable all links/cols we disabled during transition_out (menu, site title, content links, footer links, overlay)
	jQuery('a.sitetitle, .laynav a, body>.lay-content a, body>.lay-content .col, .clickable-cover, .clickable-cover-arrow, #lay-project-overlay a, #lay-project-overlay .col').css('pointer-events', '')
	// Pair with `transition_navigation_in_started` — listeners need the scope.
	window.laytheme.emit('transition_navigation_in_completed', type)
	window.laytheme.emit('navigation_in_end', type)
	status = 'ended'
	animation_lifecycle_controller.setNavigationPhase(NAVIGATION_ANIMATION_PHASES.STABLE, {
		scope: getNavigationScopeForType(type),
	})
}

var bindBeforeContentReplacementEvent = function () {
	window.laytheme.on('before_content_replacement', function () {
		animation_lifecycle_controller.setNavigationPhase(NAVIGATION_ANIMATION_PHASES.DOM_REPLACING, {
			scope: getNavigationScopeForType('normal'),
		})
		// `visibility_gate.hideScope` cancels any pending safety-reveal from a
		// prior transition before inserting — see the gate module for the race
		// it guards against. The fallback is needed here because some history
		// paths skip the regular transition_out flow.
		visibility_gate.hideScope(SCOPES.NORMAL_PAGE)
	})

	window.laytheme.on('before_content_replacement_for_project_overlay', function () {
		animation_lifecycle_controller.setNavigationPhase(NAVIGATION_ANIMATION_PHASES.DOM_REPLACING, {
			scope: getNavigationScopeForType('project_overlay'),
		})
		visibility_gate.hideScope(SCOPES.PROJECT_OVERLAY)
	})
}

var fadeIn_SiteTitle_MenuBar_Menu_etc_helper = function (contentStaggerColumnCount, uiTargetsPreset, scope) {
	if (contentStaggerColumnCount === undefined) {
		contentStaggerColumnCount = 0
	}
	// fade in site title, menubar etc at the same time we show content!
	if (isFirstLoad == true && layData.navigation_transition_use_revealing_transition_on_first_visit == 'on') {
		fadeIn_SiteTitle_MenuBar_Menu_etc(contentStaggerColumnCount, uiTargetsPreset, scope || null)
	}
	isFirstLoad = false
}

var bindNewPageEvent = function () {
	window.laytheme.on('newpageshown', function () {
		jQuery('img').each(function () {
			this.addEventListener('error', function () {
				this.classList.add('loaded-error')
			})
		})
	})
}

// get parents where we look for elements to transition in/out
var column_selectors
var column_selectors_by_navigation_type = {
	normal: undefined,
	project_overlay: undefined,
}
var getColumnSelectorsForNavigationType = function (type) {
	var key = type == 'project_overlay' ? 'project_overlay' : 'normal'
	return column_selectors_by_navigation_type[key] || column_selectors
}
var bindOnContentReady = function () {
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady, $target, isProjectOverlayObj) {
		var isProjectOverlayBool = isProjectOverlayObj != undefined && isProjectOverlayObj.isProjectOverlay

		var parentSelector = isProjectOverlayBool ? '#lay-project-overlay>.lay-content' : 'body>.lay-content'
		column_selectors = undefined
		switch (typeOfContentThatIsReady) {
			case 'desktop':
				column_selectors = [parentSelector + ' #grid', parentSelector + ' .cover-region-desktop .cover-inner', parentSelector + ' #footer']
				break
			case 'phone':
				var footerHasPhoneCPL = jQuery(parentSelector + ' #footer-custom-phone-grid').length != 0
				var hasCPL = jQuery(parentSelector + ' #custom-phone-grid').length != 0

				if (footerHasPhoneCPL && hasCPL) {
					column_selectors = [parentSelector + ' #custom-phone-grid', parentSelector + ' .cover-region-phone .cover-inner', parentSelector + ' #footer-custom-phone-grid']
				} else if (!footerHasPhoneCPL && hasCPL) {
					column_selectors = [parentSelector + ' #custom-phone-grid', parentSelector + ' .cover-region-phone .cover-inner', parentSelector + ' #footer']
				} else if (footerHasPhoneCPL && !hasCPL) {
					column_selectors = [parentSelector + ' #grid', parentSelector + ' .cover-region-desktop .cover-inner', parentSelector + ' #footer-custom-phone-grid']
				} else if (!footerHasPhoneCPL && !hasCPL) {
					column_selectors = [parentSelector + ' #grid', parentSelector + ' .cover-region-desktop .cover-inner', parentSelector + ' #footer']
				}
				break
		}

		if (Array.isArray(column_selectors) && column_selectors != undefined) {
			// only animate not-collapsed rows, or placefreely elements ( they are not in rows at all :) )
			for (let index = 0; index < column_selectors.length; index++) {
				column_selectors[index] = column_selectors[index] + ' .row[data-collapsed="false"] .col:not(.type-stack), ' + column_selectors[index] + ' .col.place-freely, ' + column_selectors[index] + ' .row[data-collapsed="false"] .show-news'
			}
		}
		column_selectors_by_navigation_type[isProjectOverlayBool ? 'project_overlay' : 'normal'] = column_selectors

		if (isFirstLoad == true && !firstLoadRevealTransitionEmitted && layData.navigation_transition_use_revealing_transition_on_first_visit == 'on') {
			firstLoadRevealTransitionEmitted = true
			var type = isProjectOverlayBool ? 'project_overlay' : 'normal'

			window.laytheme.emit('transition_in', type)
		}
	})
}

var doAfterComplete = function () {
	status = 'ended'
	var navigationType = projects_overlays.isOverlayDisplayBlock() ? 'project_overlay' : 'normal'
	animation_lifecycle_controller.setNavigationPhase(NAVIGATION_ANIMATION_PHASES.OUT_ENDED, {
		scope: getNavigationScopeForType(navigationType),
	})
	window.laytheme.emit('transition_navigation_out_completed')
	window.laytheme.emit('navigation_out_end', navigationType)
	// re-enable all links/cols we disabled during transition_out (menu, site title, content links, footer links, overlay)
	jQuery('a.sitetitle, .laynav a, body>.lay-content a, body>.lay-content .col, .clickable-cover, .clickable-cover-arrow, #lay-project-overlay a, #lay-project-overlay .col').css('pointer-events', '')
	// a stylesheet that hides .lay-content by default
	// this way .lay-content will be hidden once its dom element is replaced with the new content and it hasnt yet
	// gotten its animation-in initial inline css applied
	// this way we prevent a flash.
	// after the transition-in has ended, we remove that stylesheet ;)
	// also, we add this css using php in frontend.php if setting is on: 'Use "Revealing Transition" when first visiting website'
	visibility_gate.hideScope(SCOPES.NORMAL_PAGE)
}

export default animations_controller
